import React from 'react';
import Skeleton from 'components/Global/Skeleton/Skeleton';
import './ChargingLocatorSkeleton.scss';

const ChargingLocatorSkeleton = (): JSX.Element => {
  return (
    <div className="charging-locator-skeleton">
      <Skeleton classes="charging-locator-skeleton__panel" />
      <div className="charging-locator-skeleton__filters">
        {[...Array(4)].map((value: undefined, index: number) => (
          <Skeleton
            key={`ev-skel-filter-${index}`}
            classes="charging-locator-skeleton__filter"
          />
        ))}
      </div>
      <div className="charging-locator-skeleton__controls">
        <Skeleton classes="charging-locator-skeleton__locate-btn" />
        <Skeleton classes="charging-locator-skeleton__zoom-btns" />
      </div>
      <Skeleton classes="charging-locator-skeleton__legend" />
      <span className="charging-locator-skeleton__disclaimer" />
    </div>
  );
};

export default ChargingLocatorSkeleton;
